/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Excludefromaudittrailtenant4Inputs */

const en_entity_excludefromaudittrailtenant4 = /** @type {(inputs: Entity_Excludefromaudittrailtenant4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exclude From Audit Trail Tenant`)
};

const de_entity_excludefromaudittrailtenant4 = /** @type {(inputs: Entity_Excludefromaudittrailtenant4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vom Audit-Trail-Mandanten ausschließen`)
};

/**
* | output |
* | --- |
* | "Exclude From Audit Trail Tenant" |
*
* @param {Entity_Excludefromaudittrailtenant4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_excludefromaudittrailtenant4 = /** @type {((inputs?: Entity_Excludefromaudittrailtenant4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Excludefromaudittrailtenant4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_excludefromaudittrailtenant4(inputs)
	return de_entity_excludefromaudittrailtenant4(inputs)
});
export { entity_excludefromaudittrailtenant4 as "entity_excludeFromAuditTrailTenant" }